(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.ds-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ds-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ds-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initComparadores() {
    var comparadores = document.querySelectorAll('[data-ds-comparador]');
    comparadores.forEach(function (comparador) {
      var wrap = comparador.querySelector('[data-ds-despues-wrap]');
      var manija = comparador.querySelector('[data-ds-manija]');
      var asa = comparador.querySelector('[data-ds-asa]');
      if (!wrap || !manija) return;

      function setPos(percent) {
        percent = Math.max(0, Math.min(100, percent));
        wrap.style.width = percent + '%';
        manija.style.left = percent + '%';
        if (asa) asa.style.left = percent + '%';
      }

      function posFromEvent(clientX) {
        var rect = comparador.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      var dragging = false;

      comparador.addEventListener('pointerdown', function (e) {
        dragging = true;
        comparador.setPointerCapture(e.pointerId);
        setPos(posFromEvent(e.clientX));
      });
      comparador.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        setPos(posFromEvent(e.clientX));
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
        comparador.addEventListener(evt, function () { dragging = false; });
      });

      var inicial = parseFloat(comparador.getAttribute('data-ds-inicial')) || 50;
      setPos(inicial);
    });
  }

  function initGalerias() {
    document.querySelectorAll('[data-ds-galeria]').forEach(function (galeria) {
      var principal = galeria.querySelector('[data-ds-galeria-principal]');
      var minis = galeria.querySelectorAll('[data-ds-galeria-mini]');
      var plantillas = galeria.querySelectorAll('[data-ds-media-template]');
      var zoomBoton = galeria.querySelector('[data-ds-zoom-abrir]');
      var dialog = galeria.parentElement ? galeria.parentElement.querySelector('[data-ds-zoom-dialog]') : null;
      var zoomImagen = dialog ? dialog.querySelector('[data-ds-zoom-imagen]') : null;
      if (!principal || !plantillas.length) return;

      var indice = 0;

      function mostrar(i) {
        if (i < 0) i = plantillas.length - 1;
        if (i >= plantillas.length) i = 0;
        indice = i;
        var plantilla = plantillas[indice];
        principal.innerHTML = '';
        principal.appendChild(plantilla.content.cloneNode(true));

        var esImagen = plantilla.getAttribute('data-media-type') === 'image' || !plantilla.getAttribute('data-media-type');
        if (zoomBoton) zoomBoton.hidden = !esImagen;
        if (zoomBoton) zoomBoton.setAttribute('data-zoom-src', plantilla.getAttribute('data-zoom-src') || '');

        if (minis.length) {
          minis.forEach(function (m) { m.classList.remove('is-active'); });
          var mediaId = plantilla.getAttribute('data-media-id');
          var miniActivo = galeria.querySelector('[data-ds-galeria-mini][data-media-id="' + mediaId + '"]');
          if (miniActivo) miniActivo.classList.add('is-active');
        }
      }

      function mostrarPorMediaId(mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < plantillas.length; i++) {
          if (plantillas[i].getAttribute('data-media-id') === String(mediaId)) {
            if (i !== indice) mostrar(i);
            return;
          }
        }
      }
      galeria.dsMostrarPorMediaId = mostrarPorMediaId;

      minis.forEach(function (mini, i) {
        mini.addEventListener('click', function () { mostrar(i); });
      });

      if (zoomBoton && dialog && zoomImagen) {
        zoomBoton.addEventListener('click', function () {
          var src = zoomBoton.getAttribute('data-zoom-src');
          if (!src) return;
          zoomImagen.src = src;
          if (typeof dialog.showModal === 'function') dialog.showModal();
        });
        var cerrar = dialog.querySelector('[data-ds-zoom-cerrar]');
        if (cerrar) cerrar.addEventListener('click', function () { dialog.close(); });
        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) dialog.close();
        });
      }

      var touchInicioX = null;
      var touchArea = galeria.querySelector('[data-ds-touch-galeria]');
      if (touchArea && plantillas.length > 1) {
        touchArea.addEventListener('touchstart', function (e) {
          touchInicioX = e.changedTouches[0].clientX;
        }, { passive: true });
        touchArea.addEventListener('touchend', function (e) {
          if (touchInicioX === null) return;
          var deltaX = e.changedTouches[0].clientX - touchInicioX;
          if (Math.abs(deltaX) > 50) {
            mostrar(deltaX < 0 ? indice + 1 : indice - 1);
          }
          touchInicioX = null;
        }, { passive: true });
      }

      var mediaInicial = galeria.getAttribute('data-media-inicial');
      var indiceInicial = 0;
      if (mediaInicial) {
        for (var j = 0; j < plantillas.length; j++) {
          if (plantillas[j].getAttribute('data-media-id') === mediaInicial) {
            indiceInicial = j;
            break;
          }
        }
      }
      mostrar(indiceInicial);
    });
  }

  function initVariantes() {
    var forms = document.querySelectorAll('[data-ds-producto-form]');
    forms.forEach(function (form) {
      var dataEl = form.querySelector('[data-ds-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try {
        variantes = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      var idInput = form.querySelector('input[name="id"]');
      var precioEl = form.querySelector('[data-ds-precio-actual]');
      var precioTachadoEl = form.querySelector('[data-ds-precio-tachado]');
      var descuentoPillEl = form.parentElement ? form.parentElement.querySelector('[data-ds-descuento-pill]') : null;
      var ahorroEl = form.parentElement ? form.parentElement.querySelector('[data-ds-ahorro]') : null;
      var stockBajoEl = form.parentElement ? form.parentElement.querySelector('[data-ds-stock-bajo]') : null;
      var boton = form.querySelector('[data-ds-anadir]');
      var pildoras = form.querySelectorAll('[data-ds-pildora]');
      var galeria = form.closest('.ds-producto__grid') ? form.closest('.ds-producto__grid').querySelector('[data-ds-galeria]') : null;

      function seleccionActual() {
        var seleccionadas = [];
        form.querySelectorAll('[data-ds-opcion]').forEach(function (grupo) {
          var activo = grupo.querySelector('.is-active');
          if (activo) seleccionadas.push(activo.getAttribute('data-valor'));
        });
        return seleccionadas;
      }

      function actualizar() {
        var seleccion = seleccionActual();
        var variante = variantes.find(function (v) {
          return v.options.every(function (op, i) { return op === seleccion[i]; });
        });
        if (!variante) return;
        idInput.value = variante.id;
        if (precioEl) precioEl.textContent = variante.price_html;
        if (precioTachadoEl) {
          if (variante.en_oferta && variante.compare_at_price_html) {
            precioTachadoEl.textContent = variante.compare_at_price_html;
            precioTachadoEl.hidden = false;
          } else {
            precioTachadoEl.hidden = true;
          }
        }
        if (descuentoPillEl) {
          if (variante.en_oferta && variante.descuento_pct) {
            descuentoPillEl.textContent = '-' + variante.descuento_pct + '%';
            descuentoPillEl.hidden = false;
          } else {
            descuentoPillEl.hidden = true;
          }
        }
        if (ahorroEl) {
          if (variante.en_oferta && variante.ahorro_html) {
            ahorroEl.textContent = 'Ahorras ' + variante.ahorro_html;
            ahorroEl.hidden = false;
          } else {
            ahorroEl.hidden = true;
          }
        }
        if (stockBajoEl) {
          if (variante.stock_bajo) {
            stockBajoEl.textContent = 'Quedan ' + variante.stock_cantidad + ' en inventario';
            stockBajoEl.hidden = false;
          } else {
            stockBajoEl.hidden = true;
          }
        }
        if (boton) {
          boton.disabled = !variante.available;
          boton.textContent = variante.available
            ? boton.getAttribute('data-texto-disponible')
            : boton.getAttribute('data-texto-agotado');
        }
        pildoras.forEach(function (pild) {
          var grupo = pild.closest('[data-ds-opcion]');
          var indice = parseInt(grupo.getAttribute('data-opcion-indice'), 10);
          var valorEnEstaVariante = variante.options[indice];
          var existeCombinacion = variantes.some(function (v) {
            var copia = seleccion.slice();
            copia[indice] = pild.getAttribute('data-valor');
            return v.options.every(function (op, i) { return op === copia[i]; });
          });
          pild.disabled = !existeCombinacion;
        });

        if (galeria && variante.featured_media_id && typeof galeria.dsMostrarPorMediaId === 'function') {
          galeria.dsMostrarPorMediaId(variante.featured_media_id);
        }
      }

      form.querySelectorAll('[data-ds-pildora]').forEach(function (pild) {
        pild.addEventListener('click', function () {
          var grupo = pild.closest('[data-ds-opcion]');
          grupo.querySelectorAll('[data-ds-pildora]').forEach(function (p) { p.classList.remove('is-active'); });
          pild.classList.add('is-active');
          actualizar();
        });
      });

      actualizar();
    });
  }

  function initCantidad() {
    document.querySelectorAll('[data-ds-cantidad]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var menos = wrap.querySelector('[data-ds-menos]');
      var mas = wrap.querySelector('[data-ds-mas]');
      if (!input) return;
      if (menos) menos.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      if (mas) mas.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  }

  function initFrasesHero() {
    var reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-ds-hero-logo]').forEach(function (hero) {
      var frases = hero.querySelectorAll('.ds-hero-logo__frase');
      if (frases.length < 2 || reducirMovimiento) return;
      var actual = 0;
      var duracion = parseInt(hero.getAttribute('data-ds-frases-rotacion'), 10) || 4000;
      setInterval(function () {
        frases[actual].classList.remove('is-active');
        actual = (actual + 1) % frases.length;
        frases[actual].classList.add('is-active');
      }, duracion);
    });
  }

  function initHeroParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;
    document.querySelectorAll('[data-ds-hero-logo]').forEach(function (hero) {
      var contenido = hero.querySelector('.ds-hero-logo__contenido');
      if (!contenido) return;
      var frame = null;
      var destinoX = 0;
      var destinoY = 0;
      var actualX = 0;
      var actualY = 0;

      function paso() {
        actualX += (destinoX - actualX) * 0.08;
        actualY += (destinoY - actualY) * 0.08;
        contenido.style.transform = 'translate3d(' + actualX.toFixed(2) + 'px,' + actualY.toFixed(2) + 'px,0)';
        if (Math.abs(destinoX - actualX) > 0.05 || Math.abs(destinoY - actualY) > 0.05) {
          frame = requestAnimationFrame(paso);
        } else {
          frame = null;
        }
      }

      hero.addEventListener('mousemove', function (e) {
        var rect = hero.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        destinoX = x * -14;
        destinoY = y * -10;
        if (!frame) frame = requestAnimationFrame(paso);
      });

      hero.addEventListener('mouseleave', function () {
        destinoX = 0;
        destinoY = 0;
        if (!frame) frame = requestAnimationFrame(paso);
      });
    });
  }

  function initCursorPersonalizado() {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    var reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var cursor = document.createElement('div');
    cursor.className = 'ds-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cursor);

    var destinoX = 0;
    var destinoY = 0;
    var actualX = 0;
    var actualY = 0;
    var activo = false;
    var frame = null;

    function paso() {
      if (reducirMovimiento) {
        actualX = destinoX;
        actualY = destinoY;
      } else {
        actualX += (destinoX - actualX) * 0.25;
        actualY += (destinoY - actualY) * 0.25;
      }
      var escala = activo ? 1 : 0.5;
      cursor.style.transform = 'translate(' + actualX.toFixed(1) + 'px,' + actualY.toFixed(1) + 'px) translate(-50%,-50%) scale(' + escala + ')';
      frame = requestAnimationFrame(paso);
    }
    frame = requestAnimationFrame(paso);

    document.addEventListener('mousemove', function (e) {
      destinoX = e.clientX;
      destinoY = e.clientY;
      var sobreTarjeta = !!e.target.closest('.card-wrapper, .ds-producto-card, .ds-categoria');
      if (sobreTarjeta !== activo) {
        activo = sobreTarjeta;
        cursor.classList.toggle('is-active', activo);
        document.body.classList.toggle('ds-cursor-activo', activo);
      }
    });

    document.addEventListener('mouseleave', function () {
      cursor.classList.remove('is-active');
      document.body.classList.remove('ds-cursor-activo');
    });
  }

  function initFaq() {
    document.querySelectorAll('.ds-faq__item').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        item.parentElement.querySelectorAll('.ds-faq__item').forEach(function (otro) {
          if (otro !== item) otro.open = false;
        });
      });
    });
  }

  function refrescarBurbujaCarrito() {
    return fetch('/?section_id=cart-icon-bubble')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var actual = document.getElementById('cart-icon-bubble');
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var nuevo = temp.querySelector('#cart-icon-bubble');
        if (actual && nuevo) actual.innerHTML = nuevo.innerHTML;
      });
  }

  function abrirCarritoConRespuesta(data) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(data);
      return Promise.resolve();
    }
    return refrescarBurbujaCarrito();
  }

  function agregarAlCarrito(items, boton) {
    if (!items.length || !boton || boton.disabled) return;
    var textoOriginal = boton.textContent;
    boton.disabled = true;
    boton.textContent = boton.getAttribute('data-texto-cargando') || '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart-add-failed');
        return res.json();
      })
      .then(function (data) {
        boton.textContent = boton.getAttribute('data-texto-exito') || 'Añadido ✓';
        return abrirCarritoConRespuesta(data);
      })
      .catch(function () {
        boton.textContent = boton.getAttribute('data-texto-error') || 'No se pudo agregar';
      })
      .finally(function () {
        setTimeout(function () {
          boton.disabled = false;
          boton.textContent = textoOriginal;
        }, 1800);
      });
  }

  function initProductoFormSubmit() {
    document.querySelectorAll('[data-ds-producto-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var boton = form.querySelector('[data-ds-anadir]');
        var formData = new FormData(form);
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        if (boton) boton.disabled = true;
        fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function (data) {
            return abrirCarritoConRespuesta(data);
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            if (boton) boton.disabled = false;
          });
      });
    });
  }

  function initQuickAdd() {
    document.querySelectorAll('[data-ds-quick-add]').forEach(function (boton) {
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = boton.getAttribute('data-variant-id');
        if (!variantId) return;
        agregarAlCarrito([{ id: variantId, quantity: 1 }], boton);
      });
    });
  }

  function esqueletoQuickView() {
    return (
      '<span class="ds-skeleton ds-skeleton--texto" style="width:70%;height:22px;"></span>' +
      '<span class="ds-skeleton ds-skeleton--texto" style="width:35%;height:14px;margin-top:14px;"></span>'
    );
  }

  function initQuickView() {
    var botones = document.querySelectorAll('[data-ds-quickview]');
    if (!botones.length) return;

    var dialog = document.createElement('dialog');
    dialog.className = 'ds-quickview';
    dialog.innerHTML =
      '<button type="button" class="ds-quickview__cerrar" aria-label="Cerrar">✕</button>' +
      '<div class="ds-quickview__cuerpo">' +
      '<div class="ds-quickview__imagen"></div>' +
      '<div class="ds-quickview__info">' +
      '<h3 class="ds-quickview__titulo"></h3>' +
      '<p class="ds-quickview__precio"></p>' +
      '<div class="ds-quickview__accion"></div>' +
      '</div></div>';
    document.body.appendChild(dialog);

    var imgEl = dialog.querySelector('.ds-quickview__imagen');
    var tituloEl = dialog.querySelector('.ds-quickview__titulo');
    var precioEl = dialog.querySelector('.ds-quickview__precio');
    var accionEl = dialog.querySelector('.ds-quickview__accion');
    var cerrarBtn = dialog.querySelector('.ds-quickview__cerrar');

    cerrarBtn.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });

    botones.forEach(function (boton) {
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        var url = boton.getAttribute('data-product-url');
        if (!url) return;
        tituloEl.innerHTML = esqueletoQuickView();
        precioEl.textContent = '';
        imgEl.innerHTML = '<div class="ds-skeleton" style="width:100%;height:100%;"></div>';
        accionEl.innerHTML = '<span class="ds-skeleton" style="display:inline-block;width:160px;height:46px;border-radius:var(--ds-radio, 2px);"></span>';
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          window.location.href = url;
          return;
        }
        fetch(url + '.js')
          .then(function (res) { return res.json(); })
          .then(function (producto) {
            tituloEl.textContent = acortarTitulo(producto.title, 60);
            var variante = producto.variants[0];
            precioEl.textContent = formatoPrecio(variante.price / 100);
            imgEl.innerHTML = '';
            if (producto.featured_image) {
              var separador = producto.featured_image.indexOf('?') > -1 ? '&' : '?';
              var img = document.createElement('img');
              img.src = producto.featured_image + separador + 'width=600';
              img.alt = '';
              imgEl.appendChild(img);
            }
            accionEl.innerHTML = '';
            if (producto.variants.length === 1) {
              var botonAgregar = document.createElement('button');
              botonAgregar.type = 'button';
              botonAgregar.className = 'ds-boton ds-boton--primario';
              botonAgregar.textContent = variante.available ? 'Añadir al carrito' : 'Agotado';
              botonAgregar.disabled = !variante.available;
              botonAgregar.setAttribute('data-texto-cargando', 'Agregando…');
              botonAgregar.setAttribute('data-texto-exito', 'Añadido ✓');
              botonAgregar.addEventListener('click', function () {
                agregarAlCarrito([{ id: variante.id, quantity: 1 }], botonAgregar);
              });
              accionEl.appendChild(botonAgregar);
            }
            var link = document.createElement('a');
            link.href = url;
            link.className = 'ds-quickview__link';
            link.textContent = 'Ver producto completo';
            accionEl.appendChild(link);
          })
          .catch(function () {
            tituloEl.textContent = 'No se pudo cargar el producto';
            imgEl.innerHTML = '';
            accionEl.innerHTML = '';
          });
      });
    });
  }

  var DS_WISHLIST_KEY = 'ds_wishlist';

  function dsWishlistObtener() {
    try {
      return JSON.parse(localStorage.getItem(DS_WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function dsWishlistGuardar(lista) {
    try {
      localStorage.setItem(DS_WISHLIST_KEY, JSON.stringify(lista));
    } catch (e) {
      /* almacenamiento no disponible */
    }
  }

  function initWishlist() {
    var lista = dsWishlistObtener();
    document.querySelectorAll('[data-ds-wishlist]').forEach(function (boton) {
      var id = boton.getAttribute('data-product-id');
      if (!id) return;
      var yaGuardado = lista.some(function (item) { return item.id === id; });
      if (yaGuardado) boton.classList.add('is-active');
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        var actual = dsWishlistObtener();
        var idx = actual.findIndex(function (item) { return item.id === id; });
        if (idx > -1) {
          actual.splice(idx, 1);
          boton.classList.remove('is-active');
        } else {
          actual.push({
            id: id,
            handle: boton.getAttribute('data-product-handle') || '',
            title: boton.getAttribute('data-product-title') || '',
            image: boton.getAttribute('data-product-image') || '',
            price: parseInt(boton.getAttribute('data-product-price'), 10) || null
          });
          boton.classList.add('is-active');
        }
        dsWishlistGuardar(actual);
      });
    });
  }

  function initRutina() {
    document.querySelectorAll('[data-ds-rutina]').forEach(function (rutina) {
      var tabs = rutina.querySelectorAll('[data-ds-rutina-tab]');
      var paneles = rutina.querySelectorAll('[data-ds-rutina-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var destino = tab.getAttribute('data-target');
          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          paneles.forEach(function (p) { p.classList.remove('is-active'); });
          tab.classList.add('is-active');
          var panel = rutina.querySelector('[data-ds-rutina-panel="' + destino + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
      rutina.querySelectorAll('[data-ds-rutina-anadir]').forEach(function (boton) {
        boton.addEventListener('click', function (e) {
          e.preventDefault();
          var panel = boton.closest('[data-ds-rutina-panel]');
          if (!panel) return;
          var items = Array.prototype.slice.call(panel.querySelectorAll('[data-variant-id]')).map(function (el) {
            return { id: el.getAttribute('data-variant-id'), quantity: 1 };
          });
          agregarAlCarrito(items, boton);
        });
      });
    });
  }

  function initNewsletterForm() {
    document.querySelectorAll('[data-ds-newsletter]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var boton = form.querySelector('[data-ds-newsletter-boton]');
        if (boton) boton.textContent = boton.getAttribute('data-texto-cargando') || 'Enviando…';
      });
    });
  }

  function acortarTitulo(titulo, maxLargo) {
    titulo = (titulo || '').split('|')[0].split(' - ')[0].split(',')[0].trim();
    if (titulo.length <= maxLargo) return titulo;
    var recorte = titulo.slice(0, maxLargo);
    var ultimoEspacio = recorte.lastIndexOf(' ');
    if (ultimoEspacio > maxLargo * 0.6) recorte = recorte.slice(0, ultimoEspacio);
    return recorte.trim() + '…';
  }

  function formatoPrecio(valor) {
    try {
      return valor.toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN'
      });
    } catch (e) {
      return '$' + valor.toFixed(2);
    }
  }

  function extraerPrecioMayor(producto) {
    if (typeof producto.price === 'number') return producto.price / 100;
    if (producto.variants && producto.variants.length && producto.variants[0].price) {
      return parseFloat(producto.variants[0].price);
    }
    if (typeof producto.price_min === 'string') return parseFloat(producto.price_min);
    return null;
  }

  function extraerImagen(producto) {
    if (producto.featured_image) return producto.featured_image;
    if (producto.image) return typeof producto.image === 'string' ? producto.image : producto.image.src;
    if (producto.images && producto.images.length) {
      var primera = producto.images[0];
      return typeof primera === 'string' ? primera : primera.src;
    }
    return '';
  }

  function extraerVariantePrincipal(producto) {
    return (producto.variants && producto.variants.length && producto.variants[0]) || null;
  }

  function extraerDescuentoPct(producto) {
    var variante = extraerVariantePrincipal(producto);
    if (!variante) return null;
    var precio = parseFloat(variante.price);
    var compareAt = parseFloat(variante.compare_at_price);
    if (!compareAt || !precio || compareAt <= precio) return null;
    return Math.round(((compareAt - precio) / compareAt) * 100);
  }

  function tarjetaMiniHTML(producto) {
    var precioMayor = extraerPrecioMayor(producto);
    var precio = precioMayor != null ? formatoPrecio(precioMayor) : '';
    var imagen = extraerImagen(producto);
    var url = producto.url || (producto.handle ? '/products/' + producto.handle : '#');
    return (
      '<a href="' + url + '" class="ds-mini-producto">' +
      (imagen ? '<img src="' + imagen + '" alt="' + (producto.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
      '<span class="ds-mini-producto__nombre">' + acortarTitulo(producto.title, 34) + '</span>' +
      (precio ? '<span class="ds-mini-producto__precio">' + precio + '</span>' : '') +
      '</a>'
    );
  }

  function tarjetaEsqueletoHTML() {
    return (
      '<div class="ds-mini-producto" aria-hidden="true">' +
      '<div class="ds-skeleton" style="aspect-ratio:1/1;border-radius:var(--ds-radio-chico, 1px);"></div>' +
      '<span class="ds-skeleton ds-skeleton--texto" style="width:85%;"></span>' +
      '<span class="ds-skeleton ds-skeleton--texto" style="width:45%;"></span>' +
      '</div>'
    );
  }

  function initCarritoRecomendaciones() {
    var contenedor = document.querySelector('[data-ds-carrito-recomendaciones]');
    if (!contenedor) return;
    var productId = contenedor.getAttribute('data-product-id');
    if (!productId) return;
    var tituloSeccion = contenedor.previousElementSibling;
    contenedor.innerHTML = tarjetaEsqueletoHTML() + tarjetaEsqueletoHTML() + tarjetaEsqueletoHTML();
    contenedor.hidden = false;
    if (tituloSeccion) tituloSeccion.hidden = false;
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=3&intent=related')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var productos = (data && data.products) || [];
        if (!productos.length) {
          contenedor.hidden = true;
          if (tituloSeccion) tituloSeccion.hidden = true;
          return;
        }
        contenedor.innerHTML = productos.map(tarjetaMiniHTML).join('');
      })
      .catch(function () {
        contenedor.hidden = true;
        if (tituloSeccion) tituloSeccion.hidden = true;
      });
  }

  function initCarritoObservador() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !('MutationObserver' in window)) return;
    var espera;
    var observer = new MutationObserver(function () {
      clearTimeout(espera);
      espera = setTimeout(initCarritoRecomendaciones, 80);
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  function initVistosRecientemente() {
    var KEY = 'ds_vistos_recientemente';
    function obtener() {
      try {
        return JSON.parse(localStorage.getItem(KEY)) || [];
      } catch (e) {
        return [];
      }
    }
    function guardar(lista) {
      try {
        localStorage.setItem(KEY, JSON.stringify(lista.slice(0, 8)));
      } catch (e) {
        /* almacenamiento no disponible */
      }
    }

    var datosProducto = document.querySelector('[data-ds-producto-actual]');
    if (datosProducto) {
      var actual;
      try {
        actual = JSON.parse(datosProducto.textContent);
      } catch (e) {
        actual = null;
      }
      if (actual && actual.handle) {
        var lista = obtener().filter(function (p) { return p.handle !== actual.handle; });
        lista.unshift(actual);
        guardar(lista);
      }
    }

    var contenedor = document.querySelector('[data-ds-vistos-recientemente]');
    if (!contenedor) return;
    var actualHandle = datosProducto ? (function () {
      try { return JSON.parse(datosProducto.textContent).handle; } catch (e) { return null; }
    })() : null;
    var lista = obtener().filter(function (p) { return p.handle !== actualHandle; }).slice(0, 4);
    if (!lista.length) return;
    contenedor.innerHTML = lista.map(function (p) {
      return tarjetaMiniHTML({ url: '/products/' + p.handle, title: p.title, featured_image: p.image, price: p.price });
    }).join('');
    contenedor.hidden = false;
    var seccion = contenedor.closest('[data-ds-vistos-recientemente-seccion]');
    if (seccion) seccion.hidden = false;
  }

  function initListaDeseos() {
    var contenedor = document.querySelector('[data-ds-lista-deseos]');
    if (!contenedor) return;
    var vacioEl = document.querySelector('[data-ds-lista-deseos-vacio]');

    function render() {
      var lista = dsWishlistObtener();
      if (!lista.length) {
        contenedor.hidden = true;
        if (vacioEl) vacioEl.hidden = false;
        return;
      }
      if (vacioEl) vacioEl.hidden = true;
      contenedor.hidden = false;
      contenedor.innerHTML = lista
        .map(function (item) {
          var precio = typeof item.price === 'number' ? formatoPrecio(item.price / 100) : '';
          return (
            '<div class="ds-mini-producto ds-lista-deseos__item">' +
            '<a href="/products/' + item.handle + '">' +
            (item.image ? '<img src="' + item.image + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
            '<span class="ds-mini-producto__nombre">' + acortarTitulo(item.title, 34) + '</span>' +
            (precio ? '<span class="ds-mini-producto__precio">' + precio + '</span>' : '') +
            '</a>' +
            '<button type="button" class="ds-lista-deseos__quitar" data-id="' + item.id + '">Quitar</button>' +
            '</div>'
          );
        })
        .join('');
      contenedor.querySelectorAll('.ds-lista-deseos__quitar').forEach(function (boton) {
        boton.addEventListener('click', function () {
          var actual = dsWishlistObtener().filter(function (item) { return item.id !== boton.getAttribute('data-id'); });
          dsWishlistGuardar(actual);
          render();
        });
      });
    }

    render();
  }

  function initPopup() {
    var popup = document.querySelector('[data-ds-popup]');
    if (!popup) return;
    var KEY = 'ds_popup_visto';

    function yaVisto() {
      try {
        return !!localStorage.getItem(KEY);
      } catch (e) {
        return false;
      }
    }
    function marcarVisto() {
      try {
        localStorage.setItem(KEY, Date.now().toString());
      } catch (e) {
        /* almacenamiento no disponible */
      }
    }
    var elementoActivoPrevio = null;

    function cerrar() {
      popup.hidden = true;
      if (typeof removeTrapFocus === 'function') removeTrapFocus(elementoActivoPrevio);
    }
    function mostrar() {
      if (yaVisto()) return;
      elementoActivoPrevio = document.activeElement;
      popup.hidden = false;
      marcarVisto();
      if (typeof trapFocus === 'function') {
        var caja = popup.querySelector('.ds-popup__caja');
        trapFocus(caja, caja);
      }
    }

    popup.querySelectorAll('[data-ds-popup-cerrar]').forEach(function (el) {
      el.addEventListener('click', cerrar);
    });
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && !popup.hidden) cerrar();
    });

    var botonCopiar = popup.querySelector('[data-ds-popup-copiar]');
    if (botonCopiar) {
      botonCopiar.addEventListener('click', function () {
        var codigo = botonCopiar.getAttribute('data-codigo');
        var textoEl = botonCopiar.querySelector('[data-ds-popup-copiar-texto]');
        if (navigator.clipboard && codigo) {
          navigator.clipboard.writeText(codigo).then(function () {
            if (!textoEl) return;
            var original = textoEl.textContent;
            textoEl.textContent = '¡Copiado!';
            setTimeout(function () {
              textoEl.textContent = original;
            }, 1800);
          });
        }
      });
    }

    if (yaVisto()) return;

    var modo = popup.getAttribute('data-modo');
    var segundos = parseInt(popup.getAttribute('data-segundos'), 10) || 20;

    if (modo === 'salida') {
      var salidaListener = function (e) {
        if (e.clientY <= 0) {
          mostrar();
          document.removeEventListener('mouseleave', salidaListener);
        }
      };
      setTimeout(function () {
        document.addEventListener('mouseleave', salidaListener);
      }, 4000);
    } else {
      setTimeout(mostrar, segundos * 1000);
    }
  }

  function initTarjetaFlotante() {
    var contenedor = document.querySelector('[data-ds-flotante]');
    if (!contenedor) return;

    var segundos = parseInt(contenedor.getAttribute('data-segundos'), 10) || 30;
    var repetirSegundos = 40;
    var productId = contenedor.getAttribute('data-product-id');
    var tarjetaVisible = false;
    var pool = [];
    var indice = 0;
    var contadorTurnos = 0;

    function renderTarjetaPromo() {
      var tarjeta = document.createElement('div');
      tarjeta.className = 'ds-flotante-tarjeta ds-flotante-tarjeta--promo';
      tarjeta.innerHTML =
        '<button type="button" class="ds-flotante-tarjeta__cerrar" aria-label="Cerrar">✕</button>' +
        '<div class="ds-flotante-tarjeta__cuerpo">' +
        '<p class="ds-flotante-tarjeta__etiqueta">Oferta activa</p>' +
        '<p class="ds-flotante-tarjeta__nombre">10% en tu primer pedido</p>' +
        '<button type="button" class="ds-oferta-card__codigo" data-ds-copiar data-codigo="BIENVENIDO10" style="margin:8px 0 12px;">BIENVENIDO10<span data-ds-copiar-texto>Copiar código</span></button>' +
        '<div class="ds-flotante-tarjeta__acciones">' +
        '<a href="/pages/ofertas" class="ds-boton ds-boton--primario">Ver todas las ofertas</a>' +
        '</div></div>';
      document.body.appendChild(tarjeta);
      tarjetaVisible = true;
      function cerrarTarjeta() {
        tarjeta.remove();
        tarjetaVisible = false;
      }
      tarjeta.querySelector('.ds-flotante-tarjeta__cerrar').addEventListener('click', cerrarTarjeta);
      setTimeout(function () {
        if (document.body.contains(tarjeta)) cerrarTarjeta();
      }, 15000);
    }

    function renderTarjeta(producto) {
      var tarjeta = document.createElement('div');
      tarjeta.className = 'ds-flotante-tarjeta';
      var precioMayor = extraerPrecioMayor(producto);
      var precio = precioMayor != null ? formatoPrecio(precioMayor) : '';
      var imagen = extraerImagen(producto);
      var url = producto.url || (producto.handle ? '/products/' + producto.handle : '#');
      var variante = extraerVariantePrincipal(producto);
      var descuentoPct = extraerDescuentoPct(producto);
      var promoTexto = descuentoPct
        ? '-' + descuentoPct + '% en este producto'
        : 'Compra 2+ y ahorra 15% · 3+ ahorra 20%';
      tarjeta.innerHTML =
        '<button type="button" class="ds-flotante-tarjeta__cerrar" aria-label="Cerrar">✕</button>' +
        (imagen ? '<img src="' + imagen + '" alt="' + (producto.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
        '<div class="ds-flotante-tarjeta__cuerpo">' +
        '<p class="ds-flotante-tarjeta__etiqueta">Recomendado para ti</p>' +
        '<p class="ds-flotante-tarjeta__nombre">' + acortarTitulo(producto.title, 42) + '</p>' +
        (precio ? '<p class="ds-flotante-tarjeta__precio">' + precio + '</p>' : '') +
        '<p class="ds-flotante-tarjeta__promo">' + promoTexto + '</p>' +
        '<div class="ds-flotante-tarjeta__acciones">' +
        (variante
          ? '<button type="button" class="ds-boton ds-boton--primario" data-ds-flotante-comprar data-variant-id="' + variante.id + '" data-texto-cargando="Agregando…" data-texto-exito="Añadido ✓" data-texto-error="No se pudo agregar">Comprar</button>'
          : '') +
        '<a href="' + url + '" class="ds-boton ds-boton--secundario">Ver</a>' +
        '</div></div>';
      document.body.appendChild(tarjeta);
      tarjetaVisible = true;
      function cerrarTarjeta() {
        tarjeta.remove();
        tarjetaVisible = false;
      }
      tarjeta.querySelector('.ds-flotante-tarjeta__cerrar').addEventListener('click', cerrarTarjeta);
      setTimeout(function () {
        if (document.body.contains(tarjeta)) cerrarTarjeta();
      }, 15000);
      var botonComprar = tarjeta.querySelector('[data-ds-flotante-comprar]');
      if (botonComprar) {
        botonComprar.addEventListener('click', function (e) {
          e.preventDefault();
          agregarAlCarrito([{ id: botonComprar.getAttribute('data-variant-id'), quantity: 1 }], botonComprar);
        });
      }
    }

    function cargarPool() {
      var url = productId
        ? '/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related'
        : '/collections/todo-dorsay/products.json?limit=6';
      return fetch(url)
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          pool = (data && data.products) || [];
        })
        .catch(function () {
          pool = [];
        });
    }

    function mostrarTarjeta() {
      if (tarjetaVisible) return;
      contadorTurnos++;
      if (contadorTurnos % 3 === 0) {
        renderTarjetaPromo();
        return;
      }
      function conPool() {
        if (!pool.length) return;
        var producto = pool[indice % pool.length];
        indice++;
        renderTarjeta(producto);
      }
      if (pool.length) {
        conPool();
      } else {
        cargarPool().then(conPool);
      }
    }

    setTimeout(function () {
      cargarPool().then(mostrarTarjeta);
      setInterval(mostrarTarjeta, repetirSegundos * 1000);
    }, segundos * 1000);

    window.addEventListener(
      'scroll',
      function () {
        var yaAbajo = window.innerHeight + window.scrollY >= document.body.scrollHeight - 200;
        if (yaAbajo) mostrarTarjeta();
      },
      { passive: true }
    );
  }

  function initIdiomaPorRegion() {
    var idiomaPorPais = {
      MX: 'es', US: 'en', GB: 'en',
      AT: 'es', BE: 'es', DE: 'es', ES: 'es', FR: 'es', IE: 'es', IT: 'es', NL: 'es', PT: 'es'
    };
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        var countryInput = form.querySelector('input[name="country_code"]');
        if (!countryInput) return;
        var nuevoIdioma = idiomaPorPais[countryInput.value] || 'es';
        var localeInput = form.querySelector('input[name="locale_code"]');
        if (!localeInput) {
          localeInput = document.createElement('input');
          localeInput.type = 'hidden';
          localeInput.name = 'locale_code';
          form.appendChild(localeInput);
        }
        localeInput.value = nuevoIdioma;
      },
      true
    );
  }

  function initCopiarCodigo() {
    document.addEventListener('click', function (e) {
      var boton = e.target.closest('[data-ds-copiar]');
      if (!boton) return;
      var codigo = boton.getAttribute('data-codigo');
      var textoEl = boton.querySelector('[data-ds-copiar-texto]');
      if (!codigo || !navigator.clipboard) return;
      navigator.clipboard.writeText(codigo).then(function () {
        if (!textoEl) return;
        var original = textoEl.textContent;
        textoEl.textContent = '¡Copiado!';
        setTimeout(function () {
          textoEl.textContent = original;
        }, 1800);
      });
    });
  }

  function initQuiz() {
    document.querySelectorAll('[data-ds-quiz]').forEach(function (quiz) {
      var respuestas = { estilo: '', problema: '' };
      var paneles = quiz.querySelectorAll('[data-ds-quiz-paso]');
      var puntos = quiz.querySelectorAll('[data-ds-quiz-progreso] [data-paso]');

      function mostrarPaso(paso) {
        paneles.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-ds-quiz-paso') === String(paso));
        });
        puntos.forEach(function (punto) {
          punto.classList.toggle('is-active', punto.getAttribute('data-paso') === String(paso));
        });
      }

      function mostrarResultado(coleccionHandle) {
        quiz.querySelectorAll('[data-ds-quiz-resultado-panel]').forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-coleccion') !== coleccionHandle;
        });
        var textoEl = quiz.querySelector('[data-ds-quiz-resultado-texto]');
        if (textoEl) {
          var partes = [];
          if (respuestas.estilo) partes.push('algo ' + respuestas.estilo.toLowerCase());
          if (respuestas.problema) partes.push('para ' + respuestas.problema.toLowerCase());
          textoEl.textContent = partes.length
            ? 'Buscas ' + partes.join(', ') + '. Aquí tienes lo mejor de esta categoría.'
            : 'Aquí tienes lo mejor de esta categoría.';
        }
        mostrarPaso('resultado');
      }

      quiz.querySelectorAll('[data-ds-quiz-opcion]').forEach(function (opcion) {
        opcion.addEventListener('click', function () {
          var paso = opcion.getAttribute('data-paso');
          var valor = opcion.getAttribute('data-valor');
          var panelActual = quiz.querySelector('[data-ds-quiz-paso="' + paso + '"]');
          if (panelActual) {
            panelActual.querySelectorAll('[data-ds-quiz-opcion]').forEach(function (o) {
              o.classList.remove('is-active');
            });
          }
          opcion.classList.add('is-active');

          if (paso === '1') {
            setTimeout(function () { mostrarPaso(2); }, 200);
            quiz.setAttribute('data-quiz-coleccion', valor);
          } else if (paso === '2') {
            respuestas.estilo = valor;
            setTimeout(function () { mostrarPaso(3); }, 200);
          } else if (paso === '3') {
            respuestas.problema = valor;
            setTimeout(function () { mostrarResultado(quiz.getAttribute('data-quiz-coleccion')); }, 200);
          }
        });
      });

      quiz.querySelectorAll('[data-ds-quiz-volver]').forEach(function (boton) {
        boton.addEventListener('click', function () {
          var panelActual = boton.closest('[data-ds-quiz-paso]');
          var paso = parseInt(panelActual.getAttribute('data-ds-quiz-paso'), 10);
          mostrarPaso(paso - 1);
        });
      });

      quiz.querySelectorAll('[data-ds-quiz-reiniciar]').forEach(function (boton) {
        boton.addEventListener('click', function () {
          quiz.querySelectorAll('[data-ds-quiz-opcion]').forEach(function (o) { o.classList.remove('is-active'); });
          respuestas.estilo = '';
          respuestas.problema = '';
          quiz.removeAttribute('data-quiz-coleccion');
          mostrarPaso(1);
        });
      });
    });
  }


  function initHeaderTransparente() {
    var headers = document.querySelectorAll('.ds-header--transparente');
    if (!headers.length) return;
    var activo = false;
    function actualizar() {
      var scrolled = window.scrollY > 40;
      if (scrolled === activo) return;
      activo = scrolled;
      headers.forEach(function (h) {
        h.classList.toggle('ds-header--scrolled', scrolled);
      });
    }
    actualizar();
    window.addEventListener('scroll', actualizar, { passive: true });
  }

  function initAyudaRapida() {
    var widget = document.querySelector('[data-ds-ayuda]');
    if (!widget) return;
    var boton = widget.querySelector('[data-ds-ayuda-boton]');
    var panel = widget.querySelector('[data-ds-ayuda-panel]');
    if (!boton || !panel) return;

    boton.addEventListener('click', function () {
      var abierto = widget.classList.toggle('is-open');
      panel.hidden = !abierto;
      boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    });

    document.addEventListener('click', function (e) {
      if (widget.classList.contains('is-open') && !widget.contains(e.target)) {
        widget.classList.remove('is-open');
        panel.hidden = true;
        boton.setAttribute('aria-expanded', 'false');
      }
    });
  }


  function initClicsPremium() {
    if (window.dsAjustes && window.dsAjustes.clicsSonido === false) return;

    var SELECTOR = '.card-wrapper, .product-card-wrapper, .ds-categoria, .ds-boton--primario, .button--primary, .product-form__submit';
    var contexto = null;

    // "Confirmación" de dos notas ascendentes, tipo interfaz de consola
    // (Xbox/PlayStation): limpio y digital, pero muy bajo de volumen para
    // no sentirse como sonido de videojuego dentro de una tienda.
    function tocarTono(contexto, frecuencia, inicio, duracion, ganancia) {
      var ahora = contexto.currentTime + inicio;
      var osc = contexto.createOscillator();
      osc.type = 'sine';
      osc.frequency.value = frecuencia;

      var armonico = contexto.createOscillator();
      armonico.type = 'sine';
      armonico.frequency.value = frecuencia * 2;
      var gananciaArmonico = contexto.createGain();
      gananciaArmonico.gain.value = 0.25;

      var filtro = contexto.createBiquadFilter();
      filtro.type = 'lowpass';
      filtro.frequency.value = 4000;

      var envolvente = contexto.createGain();
      envolvente.gain.setValueAtTime(0.0001, ahora);
      envolvente.gain.exponentialRampToValueAtTime(ganancia, ahora + 0.008);
      envolvente.gain.exponentialRampToValueAtTime(0.0001, ahora + duracion);

      osc.connect(filtro);
      armonico.connect(gananciaArmonico);
      gananciaArmonico.connect(filtro);
      filtro.connect(envolvente);
      envolvente.connect(contexto.destination);

      osc.start(ahora);
      osc.stop(ahora + duracion + 0.02);
      armonico.start(ahora);
      armonico.stop(ahora + duracion + 0.02);
    }

    function tocarClic() {
      var AudioContextClass = window.AudioContext || window.webkitAudioContext;
      if (!AudioContextClass) return;
      if (!contexto) contexto = new AudioContextClass();
      if (contexto.state === 'suspended') contexto.resume();

      tocarTono(contexto, 780, 0, 0.08, 0.05);
      tocarTono(contexto, 1170, 0.055, 0.11, 0.045);
    }

    document.addEventListener('click', function (evento) {
      if (evento.target.closest(SELECTOR)) tocarClic();
    });
  }

  function dsSafeInit(fn) {
    try {
      fn();
    } catch (e) {
      console.error('[Dorsay] error en ' + (fn.name || 'init') + ':', e);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Cada init corre aislado: si una sección de una página en particular
    // lanza un error, no debe impedir que el resto (cursor, header, sonidos
    // de clic, etc.) se inicialice en el resto de páginas.
    dsSafeInit(initReveal);
    dsSafeInit(initComparadores);
    dsSafeInit(initGalerias);
    dsSafeInit(initVariantes);
    dsSafeInit(initCantidad);
    dsSafeInit(initFrasesHero);
    dsSafeInit(initHeroParallax);
    dsSafeInit(initFaq);
    dsSafeInit(initQuickAdd);
    dsSafeInit(initQuickView);
    dsSafeInit(initWishlist);
    dsSafeInit(initRutina);
    dsSafeInit(initNewsletterForm);
    dsSafeInit(initProductoFormSubmit);
    dsSafeInit(initCarritoRecomendaciones);
    dsSafeInit(initCarritoObservador);
    dsSafeInit(initVistosRecientemente);
    dsSafeInit(initPopup);
    dsSafeInit(initTarjetaFlotante);
    dsSafeInit(initListaDeseos);
    dsSafeInit(initCopiarCodigo);
    dsSafeInit(initIdiomaPorRegion);
    dsSafeInit(initQuiz);
    dsSafeInit(initAyudaRapida);
    dsSafeInit(initHeaderTransparente);
    dsSafeInit(initCursorPersonalizado);
    dsSafeInit(initClicsPremium);
  });
})();
